import axios from 'axios';
import { stringify } from 'qs';
import AppConfig from 'Constants/AppConfig';

const axiosInstance = axios.create({
  baseURL: `https://graph.facebook.com/${AppConfig.facebookGraphApiVersion}/`,
  paramsSerializer: function (params) {
    return stringify(params, { arrayFormat: 'indices', allowDots: true })
  }
});

export class GraphApiService{
  async getAccountPages(accessToken, fields){
    let response = await axiosInstance.get('me', {
      params: {
        fields: fields,
        'access_token': accessToken
      }
    })
    return response.data;
  }
  async getPageDetails(endpoint, accessToken, fields){
    let response = await axiosInstance.get(endpoint, {
      params: {
        'access_token': accessToken,
        fields: fields
      }
    })
    return response.data;
  }
}